<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="container-fluid">
					<form id="FormPaqueteSistemaxEmpresa" role="form" method="post" autocomplete="off" onSubmit="return false">
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
								<label class="form-label" for="Empresa">Empresa</label>
								<select :disabled="DisableForm" @change="GetCmbSucursales()" v-model="objPaqueteSistemaxEmpresa.IdEmpresa" name="Empresa" id="Empresa" class="form-control form-select">
									<option value=0>Seleccionar</option>
									<option v-for="(item, idx) in ListaEmpresas" :key="idx" :value="item.IdEmpresa">{{ item.NombreComercial }}</option>
								</select>
								<CValidation v-if="this.errorvalidacion.IdEmpresa" :Mensaje="'*'+errorvalidacion.IdEmpresa[0]"/>
							</div>
	
							<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
								<label class="form-label" for="Sucursal">Sucursal</label>
								<select :disabled="DisableForm" v-model="objPaqueteSistemaxEmpresa.IdSucursal" name="Sucursal" id="Sucursal" class="form-control form-select">
									<option value=0>Seleccionar</option>
									<option v-for="(item, idx) in ListaSucursales" :key="idx" :value="item.IdSucursal">{{ item.Nombre }}</option>
								</select>
								<CValidation v-if="this.errorvalidacion.IdSucursal" :Mensaje="'*'+errorvalidacion.IdSucursal[0]"/>
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-6">
								<label class="form-label" for="IdPaqueteSistema">Paquete Sistema</label>
								<select :disabled="DisableForm" @change="SetDataPaqueteSistema()" v-model="objPaqueteSistemaxEmpresa.IdPaqueteSistema" name="IdPaqueteSistema" id="IdPaqueteSistema" class="form-control form-select">
									<option value=0>Seleccionar</option>
									<option v-for="(item, idx) in ListaPaquetesSistema" :key="idx" :value="item.IdPaqueteSistema">{{ item.Nombre }}</option>
								</select>
								<CValidation v-if="this.errorvalidacion.IdPaqueteSistema" :Mensaje="'*'+errorvalidacion.IdPaqueteSistema[0]"/>
							</div>
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
								<label class="form-label" for="Vigencia">Vigencia (Meses)</label>
								<input type="text" :value="objPaqueteSistema.Vigencia" class="form-control" id="Vigencia" readonly />
							</div>
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
								<label class="form-label" for="Precio">Precio</label>
								<input type="text" :value="$formatNumber(objPaqueteSistema.Precio)" class="form-control" id="Precio" readonly />
							</div>
						</div>
						
						<div class="form-group row">
							<label class="form-label" for="Nombre">Módulos Sistema del Paquete</label>
							<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<div class="table-responsive">
									<CLoader :pConfigLoad="ConfigLoadModulos">
										<template slot="BodyFormLoad">
											<table class="table align-items-center mb-0">
												<thead>
													<tr>
														<th :class="StyleTh+' text-center'">#</th>
														<th :class="StyleTh">Nombre</th>
														<th :class="StyleTh">TipoMenu</th>
														<th :class="StyleTh">Acciones</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(lista,index) in objPaqueteSistema.Detalles" :key="index">
														<td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
														<td><p :class="StyleTd">{{lista.Nombre}}</p></td>
														<td><p :class="StyleTd">{{lista.Estatus}}</p></td>
														<td>
															<button @click="VerDetallesModulo(lista.IdModuloSistema)" class="btn btn-link text-primary px-3 mb-0 mr-1" type="button"><i aria-hidden="true" class="fas fa-eye text-primary me-2"></i>Ver Detalles</button>
														</td>
													</tr>
												</tbody>
											</table>
										</template>
									</CLoader>
								</div>
							</div>
						</div>
						<br>
					</form>
				</div>
			</template>
		</CLoader>
		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<CLoader :pConfigLoad="ConfigLoadModuloDetalles">
					<template slot="BodyFormLoad">
						<ul>
							<li v-for="(item, idx) in ListaModuloDetalles" :key="idx">{{item.Nombre}}</li>
						</ul>
					</template>
				</CLoader>
			</template>
		</CModal>
	</div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'AsginarPaquete'
export default {
    name: 'FormPaqueteSistemaxEmpresa',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objPaqueteSistemaxEmpresa: {
				IdPaquetexEmpresa: 0,
				IdPaqueteSistema: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				Nombre: '',
				FechaInicio: '',
				FechaFin: '',
				Estatus: '',
				
            },
			objPaqueteSistema:{
				Vigencia:'',
				Precio:0,
				Detalles: [],
			},
			ConfigLoadModulos:{
				ShowLoader:false,
                ClassLoad: false,
			},
			ConfigLoadModuloDetalles:{
				ShowLoader:false,
				ClassLoad: false,
			},
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			ListaEmpresas:[],
			ListaSucursales:[],               
			ListaPaquetesSistema:[],
			ListaModuloDetalles:[],
			ConfigModal:{
                ModalTitle: "Módulos",
                ModalNameId: 'ModalList',
                EmitSeccion: EmitEjecuta,
                ShowFooter: false,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
			DisableForm:false,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			if(this.objPaqueteSistemaxEmpresa.IdPaquetexEmpresa == 0) {
				await this.$http.post(
					'paquetesSistemaxEmpresa',this.objPaqueteSistemaxEmpresa
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				if (this.objPaqueteSistemaxEmpresa.Estatus == 'Inactivo'){
					await this.$http.put(
						'paquetesSistemaxEmpresa/'+this.objPaqueteSistemaxEmpresa.IdPaquetexEmpresa,
						this.objPaqueteSistemaxEmpresa
					).then((res)=>{                 
						this.EjecutaConExito(res);
					}).catch(err=>{   
						this.EjecutaConError(err);
					});
				} else {
					this.$toast.warning('El paquete ya no puede ser modificado')
				}
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		VerDetallesModulo(IdModuloSistema){
            this.bus.$emit('NewModal_'+EmitEjecuta);
			this.ListaModuloDetalles = [];
			this.ConfigLoadModuloDetalles.ShowLoader = true;
			this.$http.get('modulosSistema/'+IdModuloSistema
			).then((res)=> {
				this.ListaModuloDetalles = res.data.Detalles;
			}).finally(()=>{
				this.ConfigLoadModuloDetalles.ShowLoader = false;
			}).catch(error => console.error(err));
        },
		SetDataPaqueteSistema(){
			let paqueteSistema = this.ListaPaquetesSistema.find(elem => {
				return elem.IdPaqueteSistema ===  this.objPaqueteSistemaxEmpresa.IdPaqueteSistema
			});
			if (paqueteSistema){
				this.ConfigLoadModulos.ShowLoader = true;
				this.objPaqueteSistema.Vigencia = paqueteSistema.Vigencia;
				this.objPaqueteSistema.Precio = paqueteSistema.Precio;
				this.$http.get('paquetesSistema/'+this.objPaqueteSistemaxEmpresa.IdPaqueteSistema
				).then( (res) => {
					this.objPaqueteSistema.Detalles = res.data.Detalles;
				}).finally(()=>{
                this.ConfigLoadModulos.ShowLoader = false;
				}).catch(err => console.error(err))
			} else {
				this.objPaqueteSistema.Vigencia = '';
				this.objPaqueteSistema.Precio = 0;
				this.objPaqueteSistema.Detalles = '';
			}
		},
		GetCmbEmpresas(){
			this.$http.get("empresasCuenta",{
                params:{
                    simple: true,
					simpleroot:1
                }
            }).then((res) => {
                this.ListaEmpresas = res.data.data;             
            }).catch(err => console.error(err))		
		},
		GetCmbSucursales(){
			this.ListaSucursales = [];
			if (this.objPaqueteSistemaxEmpresa.IdEmpresa > 0) {
				this.$http.get("sucursales",{
					params:{
						IdEmpresa:this.objPaqueteSistemaxEmpresa.IdEmpresa,
						EsRoot:1,
						simple: 1,
					}
				}).then((res) => {
					this.ListaSucursales = res.data.data;             
				}).catch(err => console.error(err))		
			}
		},
		GetCmbPaqueteSistema(){
			this.$http.get("paquetesSistema",{
                params:{
                    simple: true,
                }
            }).then((res) => {
                this.ListaPaquetesSistema = res.data.data;
             
            }).catch(err => console.error(err))
		},
		Recuperar()
        {
            this.$http.get(
                "paquetesSistemaxEmpresa/"+this.objPaqueteSistemaxEmpresa.IdPaquetexEmpresa
            ).then((res) => {
                this.objPaqueteSistemaxEmpresa = res.data.data;
				if (this.objPaqueteSistemaxEmpresa.Estatus!='Inactivo'){
					this.DisableForm = true;
					// this.poBtnSave.ShowBtnSave = false;
				}
				this.GetCmbSucursales();
				this.SetDataPaqueteSistema();
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objPaqueteSistemaxEmpresa = {
				IdPaquetexEmpresa: 0,
				IdPaqueteSistema: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				Nombre: '',
				FechaInicio: '',
				FechaFin: '',
				Estatus: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.GetCmbEmpresas();
			this.GetCmbPaqueteSistema();
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objPaqueteSistemaxEmpresa.IdPaquetexEmpresa = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
